import {css} from '@logistics-frontend/blocks/theme/css'

import {ADDRESS_INFO_CONTAINER_HEIGHT_IN_PX} from '../../lib/constants'

export const addressInfo = css`
  block-size: ${ADDRESS_INFO_CONTAINER_HEIGHT_IN_PX};
`
